import { useEffect, useState } from 'react';
import { EmployerInterview } from 'util/resources';
import { EmployerInterviewResource } from 'util/resources/EmployerInterview';
import { Collection } from 'active-resource';
import { QueryProps } from 'util/resources/APILibrary';

type useEmployerInterviewsProps = {
  initialQueryProps?: QueryProps;
  initiallyFetch?: boolean;
};

export const useEmployerInterviews = (
  props?: useEmployerInterviewsProps,
): {
  interviews: EmployerInterviewResource[];
  error: Error;
  loading: boolean;
  fetchInterviews: (queryProps: QueryProps) => void;
} => {
  const { initialQueryProps, initiallyFetch = true } = props || {};
  const [interviews, setInterviews] = useState<EmployerInterviewResource[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>(null);

  const fetchInterviews = (queryProps?: QueryProps) => {
    const { includes, select, where, limit = 25, offset = 0 } = queryProps || {};
    setLoading(true);

    EmployerInterview.includes(...(includes || []))
      .select(...(select || []))
      .where(where || {})
      .limit(limit)
      .offset(offset)
      .all()
      .then((response: Collection<EmployerInterviewResource>) => {
        setInterviews(response.toArray());
        setLoading(false);
      })
      .catch((err: Error) => {
        setError(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (initiallyFetch) {
      void fetchInterviews(initialQueryProps);
    }
  }, []);

  return {
    interviews,
    loading,
    error,
    fetchInterviews,
  };
};
